export function ForecastReportedLegendEntry({
  label,
  pastColor,
  futureColor,
  isSplit,
  isVisible,
  isDisabled,
  onClick,
  testId,
  swatchTestId,
  title,
}: {
  label: string;
  pastColor: string;
  futureColor: string;
  isSplit: boolean;
  isVisible: boolean;
  isDisabled: boolean;
  onClick: () => void;
  testId?: string;
  swatchTestId?: string;
  title?: string;
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      title={title}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '6px 12px',
        border: '1px solid #E5E7EB',
        borderRadius: '6px',
        backgroundColor: isVisible ? '#FFFFFF' : '#F9FAFB',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isVisible ? 1 : 0.5,
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        if (!isDisabled) {
          e.currentTarget.style.backgroundColor = isVisible
            ? '#F3F4F6'
            : '#F9FAFB';
          e.currentTarget.style.borderColor = '#D1D5DB';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = isVisible
          ? '#FFFFFF'
          : '#F9FAFB';
        e.currentTarget.style.borderColor = '#E5E7EB';
      }}
    >
      {isSplit ? (
        // Split circle for split lines (left half one color, right half another)
        <div
          className="w-3 h-3 rounded-full flex-shrink-0"
          data-testid={swatchTestId}
          style={{
            background: isVisible
              ? `linear-gradient(to right, ${pastColor} 50%, ${futureColor} 50%)`
              : 'linear-gradient(to right, #9CA3AF 50%, #9CA3AF 50%)',
          }}
        />
      ) : (
        // Solid circle for single-segment lines
        <div
          className="w-3 h-3 rounded-full flex-shrink-0"
          data-testid={swatchTestId}
          style={{
            backgroundColor: isVisible ? pastColor : '#9CA3AF',
          }}
        />
      )}
      <span
        style={{
          color: isVisible ? '#374151' : '#9CA3AF',
          fontSize: '14px',
        }}
      >
        {label}
      </span>
    </button>
  );
}
